// extracted by mini-css-extract-plugin
module.exports = {"proposalRow":"OdocTable_proposalRow_14dx4"};